/* ==========================================================================
   Dyese Analyse v2 — dyese-render.js  (rendu pur : analysis -> DOM)
   --------------------------------------------------------------------------
   Aucun accès réseau. Reçoit l'objet `analysis` (produit par le Worker /
   core/aggregate.js) + un objet `config` (charte + produits Shopify) et
   construit l'interface. Exposé en global window.DyeseRender (compatible
   inline démo) et via module.exports (tests Node).

   Règle d'or HONNÊTETÉ : les libellés de capacité et la reco produit
   n'affirment une élimination QUE lorsque analysis.indicateurs[].traitement
   l'autorise. Les composés dissous (bloc chimique/PFAS) sont explicitement
   annoncés comme NON retenus par la microfiltration 0,2 µm.
   ======================================================================== */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.DyeseRender = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* ----------------------------- utilitaires ---------------------------- */
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var nf = function (v) {
    if (v == null || !isFinite(v)) return '—';
    var abs = Math.abs(v);
    var dec = abs === 0 ? 0 : abs < 0.1 ? 3 : abs < 1 ? 3 : abs < 10 ? 2 : abs < 100 ? 1 : 0;
    try { return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: dec }).format(v); }
    catch (e) { return String(v); }
  };

  /* ------------------------------- icônes ------------------------------- */
  var I = {
    microbe: '<circle cx="12" cy="12" r="6"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>',
    drop: '<path d="M12 3s6 6.5 6 11a6 6 0 1 1-12 0c0-4.5 6-11 6-11Z"/>',
    particles: '<circle cx="6" cy="7" r="1.6"/><circle cx="17" cy="6" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="8" cy="16" r="1.6"/><circle cx="17" cy="16" r="1.6"/>',
    flask: '<path d="M9 3h6M10 3v6l-5 8a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3l-5-8V3"/>',
    leaf: '<path d="M4 20C4 11 11 4 20 4c0 9-7 16-16 16ZM4 20c4-4 7-6 10-7"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    warn: '<path d="M12 3 2 20h20L12 3Z"/><path d="M12 10v5M12 18h.01"/>',
    cross: '<path d="M18 6 6 18M6 6l12 12"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
    chev: '<path d="m6 9 6 6 6-6"/>',
    shield: '<path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z"/>',
    dl: '<path d="M12 3v12M7 11l5 5 5-5M5 21h14"/>',
  };
  var svg = function (name, cls) {
    return '<svg class="' + (cls || '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (I[name] || '') + '</svg>';
  };

  /* ------------------------- puce de statut ----------------------------- */
  // TOUJOURS icône + libellé (jamais couleur seule) — accessibilité AA.
  var STATUT_META = {
    vert:  { cls: 'good', icon: 'check', label: 'Bon' },
    ambre: { cls: 'warn', icon: 'warn',  label: 'À surveiller' },
    rouge: { cls: 'bad',  icon: 'cross', label: 'Dépassement' },
    sans:  { cls: 'info', icon: 'info',  label: 'Informatif' },
    inconnu:{ cls: 'info', icon: 'info', label: 'Non comparable' },
    info:  { cls: 'info', icon: 'info',  label: 'Informatif' },
  };
  function chip(statut, overrideLabel) {
    var m = STATUT_META[statut] || STATUT_META.info;
    return '<span class="dy-chip dy-chip--' + m.cls + '">' + svg(m.icon) +
      esc(overrideLabel || m.label) + '</span>';
  }

  /* ------------------------ bandeau capacité ---------------------------- */
  function capBanner(indic) {
    var t = indic.traitement || {};
    if (indic.id === 'bacterio')
      return '<span class="dy-cap dy-cap--yes">' + svg('shield') + 'Retenu par la microfiltration 0,2 µm</span>';
    if (indic.id === 'particule')
      return '<span class="dy-cap dy-cap--yes">' + svg('shield') + 'Particules ≥ 0,2 µm retenues</span>';
    if (indic.id === 'gout')
      return '<span class="dy-cap dy-cap--yes">' + svg('shield') + 'Réduit par le charbon actif</span>';
    if (indic.id === 'chimique')
      return '<span class="dy-cap dy-cap--no">' + svg('info') + 'Composés dissous : non retenus par la microfiltration 0,2 µm</span>';
    if (indic.id === 'mineraux')
      return '<span class="dy-cap dy-cap--yes">' + svg('leaf') + 'Minéraux conservés à 100 % (vs osmose)</span>';
    return '';
  }

  /* ------------------------------ jauge --------------------------------- */
  function gauge(sub) {
    // Pas de jauge pour minéraux/informatif ou micro binaire ou non comparable.
    if (!sub.seuil || sub.seuil.valeur == null) return '';
    if (sub.statut === 'inconnu' || sub.statut === 'sans') return '';
    if (sub.seuil.valeur === 0) return ''; // micro « doit être 0 » : le chip suffit

    var HEAD = 1.3;                                   // 30 % de marge au-delà du seuil
    var ratio = sub.ratio == null ? 0 : sub.ratio;
    var curPct = Math.max(1.5, Math.min(ratio / HEAD, 1) * 100);
    var thrPct = (1 / HEAD) * 100;
    var kind = sub.statut === 'rouge' ? 'bad' : sub.statut === 'ambre' ? 'warn' : 'good';
    var vtxt = nf(sub.valeurMax) + ' ' + esc(sub.unite) + ' sur un seuil de ' + nf(sub.seuil.valeur) + ' ' + esc(sub.seuil.unite || sub.unite);
    return '' +
      '<div class="dy-gauge">' +
        '<div class="dy-gauge__track" role="meter" aria-valuemin="0" aria-valuemax="' + esc(sub.seuil.valeur) +
          '" aria-valuenow="' + esc(sub.valeurMax) + '" aria-valuetext="' + vtxt + '">' +
          '<div class="dy-gauge__thr" style="left:' + thrPct.toFixed(1) + '%"></div>' +
          '<div class="dy-gauge__cursor dy-gauge__cursor--' + kind + '" style="left:' + curPct.toFixed(1) + '%"></div>' +
        '</div>' +
        '<div class="dy-gauge__scale"><span>0</span><span>seuil : ' + nf(sub.seuil.valeur) + ' ' + esc(sub.seuil.unite || sub.unite) + '</span></div>' +
      '</div>';
  }

  /* --------------------------- une substance ---------------------------- */
  function subCard(sub) {
    var statut = sub.statut;
    var chipLabel = null;
    if (sub.seuil && sub.seuil.valeur === 0) chipLabel = sub.detecte ? 'Détecté' : 'Absent';
    var valTxt = (sub.detecte || sub.valeurMax > 0)
      ? '<span class="dy-sub__val">' + nf(sub.valeurMax) + ' <small>' + esc(sub.unite) + '</small></span>'
      : '<span class="dy-sub__val" style="color:var(--dy-muted)">non détecté</span>';
    var meta = sub.nbMesures + ' mesure' + (sub.nbMesures > 1 ? 's' : '') +
      (sub.seuil ? ' · seuil ' + (sub.seuil.type === 'reference' ? 'de référence' : 'réglementaire') : ' · pas de seuil réglementaire');
    return '' +
      '<div class="dy-sub">' +
        '<div class="dy-sub__top">' +
          '<div><div class="dy-sub__name">' + esc(sub.nom) + '</div>' +
            '<div class="dy-sub__meta">' + esc(meta) + '</div></div>' +
          '<div style="display:flex;gap:10px;align-items:center">' + valTxt + chip(statut, chipLabel) + '</div>' +
        '</div>' +
        gauge(sub) +
      '</div>';
  }

  /* ------------------------------ un bloc ------------------------------- */
  function blockEl(indic, idx) {
    var open = idx < 2 ? ' open' : ''; // les 2 premiers blocs ouverts par défaut
    var subs = indic.substances || [];
    // On met en avant ce qui compte (détecté / ambre / rouge / non comparable)
    // et on REPLIE les paramètres recherchés mais non détectés (souvent 200+).
    var important = subs.filter(function (s) { return s.detecte || s.statut === 'ambre' || s.statut === 'rouge' || s.statut === 'inconnu'; });
    var routine = subs.filter(function (s) { return important.indexOf(s) < 0; });
    var body = '';
    if (important.length) body += '<div class="dy-subs">' + important.map(subCard).join('') + '</div>';
    if (routine.length) {
      var n = routine.length;
      var pl = n > 1 ? 's' : '';
      body += '<details class="dy-more"><summary>' + n + ' autre' + pl + ' paramètre' + pl + ' recherché' + pl + ', non détecté' + pl + '</summary>' +
        '<div class="dy-subs" style="margin-top:10px">' + routine.map(subCard).join('') + '</div></details>';
    }
    if (!subs.length) body = '<p class="dy-sub__meta">Aucune donnée sur 12 mois pour cet indicateur.</p>';

    var pfasHtml = (indic.id === 'chimique' && indic._pfas) ? pfasBlock(indic._pfas) : '';

    var srcs = (indic.sources || []).join(' · ');
    var det = document.createElement('details');
    det.id = 'dy-bloc-' + indic.id;
    var sb = indic.statutBloc;
    det.className = 'dy-block dy-block--' +
      (sb === 'rouge' ? 'bad' : sb === 'ambre' ? 'warn' : sb === 'vert' ? 'good' : 'info');
    if (open) det.open = true;
    det.innerHTML = '' +
      '<summary class="dy-block__head">' +
        '<span class="dy-block__icon">' + svg(indic.icone || 'flask') + '</span>' +
        '<span class="dy-block__title"><h3>' + esc(indic.titre) + '</h3>' +
          '<p>' + statutBlocTexte(indic.statutBloc) + '</p></span>' +
        chip(indic.statutBloc === 'info' ? 'info' : indic.statutBloc) +
        '<span class="dy-block__chev">' + svg('chev') + '</span>' +
      '</summary>' +
      '<div class="dy-block__body">' +
        capBanner(indic) +
        '<p class="dy-block__intro">' + esc(indic.intro) + '</p>' +
        pfasHtml +
        body +
        '<p class="dy-sources"><strong>Sources :</strong> ' + esc(srcs) + '</p>' +
      '</div>';
    return det;
  }

  function statutBlocTexte(s) {
    return s === 'rouge' ? 'Un dépassement relevé' :
           s === 'ambre' ? 'À surveiller' :
           s === 'info' ? 'Informations minérales' : 'Rien à signaler';
  }

  /* --------------------------- bloc PFAS -------------------------------- */
  function pfasBlock(pfas) {
    var kind = pfas.statut === 'rouge' ? 'bad' : pfas.statut === 'ambre' ? 'warn' : 'good';
    return '' +
      '<div class="dy-pfas">' +
        '<div class="dy-pfas__row">' +
          '<div><strong>Somme des 20 PFAS</strong><div class="dy-sub__meta">' +
            pfas.nbMembresDetectes + '/' + pfas.nbMembresMesures + ' PFAS détecté(s) · somme ' + (pfas.origine) + '</div></div>' +
          '<div style="display:flex;gap:10px;align-items:center">' +
            '<span class="dy-sub__val">' + nf(pfas.sommeUgL) + ' <small>µg/L</small></span>' + chip(pfas.statut) +
          '</div>' +
        '</div>' +
        '<div class="dy-gauge"><div class="dy-gauge__track" role="meter" aria-valuemin="0" aria-valuemax="' + pfas.seuilUgL +
          '" aria-valuenow="' + pfas.sommeUgL + '" aria-valuetext="' + nf(pfas.sommeUgL) + ' µg/L sur un seuil de ' + pfas.seuilUgL + ' µg/L">' +
          '<div class="dy-gauge__thr" style="left:' + (100 / 1.3).toFixed(1) + '%"></div>' +
          '<div class="dy-gauge__cursor dy-gauge__cursor--' + kind + '" style="left:' + Math.max(1.5, Math.min(pfas.ratio / 1.3, 1) * 100).toFixed(1) + '%"></div></div>' +
          '<div class="dy-gauge__scale"><span>0</span><span>seuil : ' + pfas.seuilUgL + ' µg/L (' + esc(pfas.seuilOrigine) + ')</span></div></div>' +
        '<p class="dy-pfas__note">' + svg('info') + ' Les PFAS sont des composés <strong>dissous</strong> : la microfiltration 0,2 µm ne les retient pas. Donnée affichée par transparence — voir la gamme sous-évier / en ligne à média spécifiques.</p>' +
      '</div>';
  }


  /* ================= COMPOSITION — familles de substances ================= */
  // Classement par nom (l'API ne renvoie pas de famille). Emoji = repere visuel,
  // aria-hidden : le sens est toujours porte par le libelle.
  var FAMILLES = [
    { id: 'pfas',      emo: '\u267E\uFE0F', nom: 'PFAS \u00ab polluants \u00e9ternels \u00bb', desc: 'Compos\u00e9s quasi indestructibles, issus des industries et des objets du quotidien.',
      re: /pfas|perfluor|polyfluor|\bpf[bhpond][a-z]{1,3}\b/i },
    { id: 'pesticide', emo: '\uD83C\uDF3F', nom: 'Pesticides & m\u00e9tabolites', desc: 'R\u00e9sidus de traitements agricoles et leurs produits de d\u00e9gradation, qui persistent dans les nappes.',
      re: /pesticide|m\u00e9tabolite|metolachlor|atrazin|glyphosat|ampa|chloridazon|desphenyl|esa\b|oxa\b|herbicid/i },
    { id: 'chlore',    emo: '\uD83E\uDEE7', nom: 'Chlore & sous-produits', desc: 'Sous-produits du d\u00e9sinfectant qui prot\u00e8ge l\u2019eau dans les canalisations.',
      re: /chlore|chloroform|trihalom\u00e9thane|thm|bromoform|dibromo|dichloro|chlorat|chlorit|halo.?ac\u00e9tique/i },
    { id: 'azote',     emo: '\uD83E\uDDEA', nom: 'Compos\u00e9s azot\u00e9s', desc: 'Nitrates et nitrites — signature des apports agricoles et domestiques.',
      re: /nitrat|nitrit|ammonium/i },
    { id: 'metaux',    emo: '\uD83C\uDF8A', nom: 'M\u00e9taux & solvants', desc: 'M\u00e9taux et solvants — canalisations, activit\u00e9s anciennes.',
      re: /plomb|nickel|cuivre|chrome|arsenic|cadmium|baryum|aluminium|fer\b|mangan\u00e8se|antimoine|s\u00e9l\u00e9nium|mercure|solvant|t\u00e9trachlor|trichlor\u00e9th|benz\u00e8ne/i },
  ];
  function familleDe(sub) {
    var n = String(sub.nom || '');
    for (var i = 0; i < FAMILLES.length; i++) if (FAMILLES[i].re.test(n)) return FAMILLES[i];
    return null;
  }
  function compositionSection(analysis) {
    // On ne compte que ce qui est REELLEMENT detecte (honnetete : « detecte » != « dangereux »).
    var buckets = {};
    (analysis.indicateurs || []).forEach(function (indic) {
      if (indic.id === 'mineraux') return;
      (indic.substances || []).forEach(function (sub) {
        if (!sub.detecte) return;
        var f = familleDe(sub);
        if (!f) return;
        (buckets[f.id] = buckets[f.id] || { fam: f, n: 0, bloc: indic.id }).n++;
      });
    });
    var cards = FAMILLES.map(function (f) { return buckets[f.id]; }).filter(Boolean);
    if (!cards.length) return '';
    var commune = (analysis.commune && analysis.commune.nom) || 'votre commune';
    return '' +
      '<p class="dy-eyebrow" id="dy-composition">La composition de l\u2019eau \u00e0 ' + esc(commune) + '</p>' +
      verreHTML(analysis) +
      '<div class="dy-fams">' + cards.map(function (c) {
        var pl = c.n > 1 ? 's' : '';
        return '' +
          '<div class="dy-fam">' +
            '<div class="dy-fam__head"><span class="dy-fam__emo" aria-hidden="true">' + c.fam.emo + '</span>' +
              '<h3 class="dy-fam__name">' + esc(c.fam.nom) + '</h3></div>' +
            '<p class="dy-fam__n">' + c.n + '<small>substance' + pl + '</small></p>' +
            '<p class="dy-fam__desc">' + esc(c.fam.desc) + '</p>' +
            '<a class="dy-fam__link" href="#dy-bloc-' + esc(c.bloc) + '">Voir ' + (c.n > 1 ? 'les ' + c.n + ' substances' : 'la substance') + ' \u2192</a>' +
          '</div>';
      }).join('') + '</div>';
  }

  /* ================= A RETENIR — cartes de seuil (top 4) ================== */
  function focusSection(analysis) {
    var all = [];
    (analysis.indicateurs || []).forEach(function (indic) {
      if (indic.id === 'mineraux') return;
      (indic.substances || []).forEach(function (sub) {
        if (!sub.detecte) return;
        all.push({ sub: sub, indic: indic });
      });
    });
    if (!all.length) return '';
    var rank = { rouge: 3, ambre: 2, vert: 1, sans: 0, inconnu: 0 };
    all.sort(function (a, b) {
      var d = (rank[b.sub.statut] || 0) - (rank[a.sub.statut] || 0);
      if (d) return d;
      return (b.sub.ratio || 0) - (a.sub.ratio || 0);
    });
    var top = all.slice(0, 4);
    var nAtt = all.filter(function (x) { return x.sub.statut === 'ambre' || x.sub.statut === 'rouge'; }).length;
    var reste = all.length - nAtt;
    var lead = nAtt
      ? '<strong>' + nAtt + ' point' + (nAtt > 1 ? 's appellent' : ' appelle') + ' une attention particuli\u00e8re.</strong> ' +
        (reste ? 'Les ' + reste + ' autre' + (reste > 1 ? 's' : '') + ' substance' + (reste > 1 ? 's' : '') + ' d\u00e9tect\u00e9e' + (reste > 1 ? 's' : '') + ' rest' + (reste > 1 ? 'ent' : 'e') + ' nettement sous leur seuil.' : '')
      : '<strong>Aucun point d\u2019attention sur la p\u00e9riode.</strong> Les ' + all.length + ' substance' + (all.length > 1 ? 's d\u00e9tect\u00e9es restent' : ' d\u00e9tect\u00e9e reste') + ' nettement sous les seuils r\u00e9glementaires.';
    var commune = (analysis.commune && analysis.commune.nom) || 'votre commune';

    return '' +
      '<p class="dy-eyebrow" id="dy-retenir">\u00c0 retenir \u00e0 ' + esc(commune) + '</p>' +
      '<p class="dy-retenir__lead">' + lead + '</p>' +
      '<div class="dy-focus">' + top.map(function (x) {
        var sub = x.sub, f = familleDe(sub);
        var st = sub.statut;
        var kind = st === 'rouge' ? 'bad' : st === 'ambre' ? 'warn' : 'good';
        var cardCls = st === 'rouge' ? ' dy-fcard--bad' : st === 'ambre' ? ' dy-fcard--warn' : '';
        var big = (sub.ratio != null && sub.seuil && sub.seuil.valeur)
          ? nf(Math.round(sub.ratio * 100)) + ' %<small>du seuil</small>'
          : nf(sub.valeurMax) + ' ' + esc(sub.unite) + '<small>valeur max</small>';
        var meta = 'Pic mesur\u00e9 : <b>' + nf(sub.valeurMax) + ' ' + esc(sub.unite) + '</b> \u00b7 ' +
          sub.nbMesures + ' mesure' + (sub.nbMesures > 1 ? 's' : '') + ' sur 12 mois';
        var note = sub.seuil
          ? (sub.seuil.type === 'reference'
              ? 'Seuil de r\u00e9f\u00e9rence (indicatif) et non limite sanitaire opposable.'
              : 'Limite de qualit\u00e9 r\u00e9glementaire — valeur oppos\u00e9e au contr\u00f4le sanitaire.')
          : 'Aucun seuil r\u00e9glementaire pour ce param\u00e8tre : valeur donn\u00e9e \u00e0 titre indicatif.';
        return '' +
          '<div class="dy-fcard' + cardCls + '">' +
            '<p class="dy-fcard__fam">' + (f ? '<span aria-hidden="true">' + f.emo + '</span>' : '') +
              esc(f ? f.nom : x.indic.titre) + '</p>' +
            '<h3 class="dy-fcard__name">' + esc(sub.nom) + '</h3>' +
            '<p class="dy-fcard__val dy-fcard__val--' + kind + '">' + big + '</p>' +
            gauge(sub) +
            '<p class="dy-fcard__meta">' + meta + '</p>' +
            '<p class="dy-fcard__note">' + note + '</p>' +
          '</div>';
      }).join('') + '</div>';
  }


  /* ===================== LOT B — composants de recit ====================== */

  /* Verre a molecules : une pastille par substance detectee, couleur = famille.
     Positions deterministes (seed = index) : le verre ne bouge pas d'un rendu
     a l'autre. Chaque pastille porte une bordure : le sens ne depend jamais
     d'un aplat (cf. regle de charte). */
  var FAM_COLOR = {
    pfas: '#7a4f0c', pesticide: '#3b6d11', chlore: '#0e6f8a',
    azote: '#5b4b8a', metaux: '#8a4b1f', autre: '#4a6a8a',
  };
  function verreHTML(analysis) {
    var pts = [];
    (analysis.indicateurs || []).forEach(function (indic) {
      if (indic.id === 'mineraux') return;
      (indic.substances || []).forEach(function (sub) {
        if (!sub.detecte) return;
        var f = familleDe(sub);
        pts.push({ nom: sub.nom, fam: f ? f.id : 'autre' });
      });
    });
    if (!pts.length) return '';
    var dots = pts.map(function (pt, i) {
      // suite deterministe (pas de Math.random) — repartition visuellement aleatoire
      var x = ((i * 61) % 79) / 100 * 78 + 8;
      var y = ((i * 37 + 11) % 71) / 100 * 74 + 8;
      var c = FAM_COLOR[pt.fam] || FAM_COLOR.autre;
      return '<span class="dy-verre__dot" style="left:' + x.toFixed(1) + '%;bottom:' + y.toFixed(1) +
        '%;background:' + c + ';border-color:' + c + '" title="' + esc(pt.nom) + '"></span>';
    }).join('');
    var byFam = {};
    pts.forEach(function (pt) { byFam[pt.fam] = (byFam[pt.fam] || 0) + 1; });
    var legend = FAMILLES.filter(function (f) { return byFam[f.id]; }).map(function (f) {
      return '<span class="dy-verre__leg"><i style="background:' + (FAM_COLOR[f.id] || FAM_COLOR.autre) +
        ';border-color:' + (FAM_COLOR[f.id] || FAM_COLOR.autre) + '"></i>' + byFam[f.id] + ' ' + esc(f.nom.toLowerCase()) + '</span>';
    }).join('');
    return '' +
      '<div class="dy-verre">' +
        '<p class="dy-verre__n"><b>' + pts.length + '</b> molécule' + (pts.length > 1 ? 's' : '') + '<br>dans le même verre</p>' +
        '<div class="dy-verre__glass" role="img" aria-label="' + pts.length +
          ' substances différentes détectées dans l\u2019eau distribuée">' +
          '<div class="dy-verre__eau">' + dots + '</div>' +
        '</div>' +
        '<div class="dy-verre__legs">' + legend + '</div>' +
      '</div>';
  }

  /* Bandeau CTA intercalaire — renvoie vers le formulaire de rapport. */
  function ctaBanner(titre, sous) {
    return '' +
      '<div class="dy-cta">' +
        '<div><p class="dy-cta__t">' + esc(titre) + '</p><p class="dy-cta__s">' + esc(sous) + '</p></div>' +
        '<a class="dy-btn" href="#dy-lead">Recevoir mon rapport</a>' +
      '</div>';
  }

  /* Barre de confiance : ce sur quoi repose l'analyse. */
  function trustBar(analysis) {
    var nbInd = (analysis.indicateurs || []).length;
    var cell = function (v, l) {
      return '<div class="dy-trust__c"><div class="dy-trust__v">' + esc(v) + '</div><div class="dy-trust__l">' + esc(l) + '</div></div>';
    };
    return '' +
      '<section class="dy-trust" aria-label="Sur quoi repose cette analyse">' +
        '<p class="dy-eyebrow" style="margin-top:0">Sur quoi repose cette analyse</p>' +
        '<div class="dy-trust__grid">' +
          cell(analysis.nbPrelevements, 'prélèvements analysés (12 mois)') +
          cell(analysis.nbParametres, 'paramètres recherchés par l\u2019ARS') +
          cell(nbInd, 'indicateurs Dyese') +
          cell('100 %', 'données publiques officielles') +
        '</div>' +
        '<details class="dy-trust__how"><summary>Comment ces indicateurs sont-ils calculés ?</summary>' +
          '<p>Chaque paramètre est agrégé sur <b>12 mois glissants</b> : on retient la <b>valeur maximale</b> mesurée, ' +
          'le nombre de mesures et le seuil renvoyé par l\u2019API (limite de qualité ou référence), avec son unité. ' +
          'Le statut compare cette valeur au seuil : vert sous 50 %, ambre entre 50 et 100 %, rouge au-delà. ' +
          'Les indicateurs Dyese (regroupement en 5 familles, somme des 20 PFAS) sont <b>non réglementaires</b> ' +
          'et calculés de façon transparente à partir des données officielles.</p>' +
        '</details>' +
        '<p class="dy-trust__src">Sources : contrôle sanitaire ARS via Hub\u2019Eau · Directive UE 2020/2184 · ANSES.</p>' +
      '</section>';
  }

  /* Nav d'ancres collante — reprise de lecture sur une page longue. */
  function ancresNav(analysis) {
    var items = [];
    items.push({ h: '#dy-composition', l: 'Composition' });
    items.push({ h: '#dy-retenir', l: 'À retenir' });
    (analysis.indicateurs || []).forEach(function (i) {
      items.push({ h: '#dy-bloc-' + i.id, l: (DIAG_LABEL[i.id] || i.titre).split('—')[0].split('&')[0].trim() });
    });
    items.push({ h: '#dy-reco', l: 'Solutions' });
    return '<nav class="dy-anchors" aria-label="Sections de l\u2019analyse">' +
      items.map(function (it) { return '<a href="' + it.h + '">' + esc(it.l) + '</a>'; }).join('') + '</nav>';
  }

  /* --------------------------- reco produit ----------------------------- */
  // Mappe les besoins (calculés côté serveur) vers les produits configurés.
  var RECO_MAP = {
    robinet_douche: ['robinet', 'douche'],
    robinet_charbon: ['robinet_charbon'],
    douche: ['douche'],
    sous_evier: ['sous_evier'],
    bofi: ['bofi'],
  };
  function recoSection(analysis, config) {
    var b = analysis.besoins || {};
    var prods = (config && config.products) || {};
    var keys = (RECO_MAP[b.primaire] || ['bofi']).slice();
    (b.secondaires || []).forEach(function (s) {
      (RECO_MAP[s] || []).forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); });
    });

    var lead = b.flags && b.flags.eauDejaBonne
      ? "Bonne nouvelle : votre eau est déjà d'excellente qualité sur les paramètres analysés. Pas besoin de sur-traiter — voici ce qui a du sens."
      : "Voici l'appareil qui correspond réellement à ce que révèle votre eau — sans promesse que la technologie ne tient pas.";

    var cards = keys.map(function (k, i) {
      var p = prods[k] || { titre: '(Produit ' + k + ')', desc: 'À configurer dans config.products.', url: '#', variant: '' };
      var primary = i === 0;
      return '' +
        '<div class="dy-prod' + (primary ? ' dy-prod--primary' : '') + '">' +
          '<div class="dy-prod__tag">' + (primary ? 'Recommandé' : 'Complément') + '</div>' +
          '<h4>' + esc(p.titre) + '</h4>' +
          '<p>' + esc(p.desc) + '</p>' +
          '<a class="dy-btn' + (primary ? '' : ' dy-btn--ghost') + '" href="' + esc(p.url) + '" data-dy-product="' + esc(k) + '">Voir le produit</a>' +
        '</div>';
    }).join('');

    var honest = b.messageChimiqueDissous
      ? '<div class="dy-honest"><strong>En toute transparence :</strong> ' + esc(b.messageChimiqueDissous) + '</div>'
      : '';

    return '' +
      '<section class="dy-reco" id="dy-reco" aria-label="Recommandation produit">' +
        '<h2>Ce qui correspond à votre eau</h2>' +
        '<p class="dy-reco__lead">' + esc(lead) + '</p>' +
        '<div class="dy-prods">' + cards + '</div>' +
        honest +
      '</section>';
  }

  /* --------------------------- verdict + kpis --------------------------- */
  // Carte-verdict : dégradé navy, pastilles de diagnostic, KPI translucides.
  var DIAG_ORDER = ['bacterio', 'gout', 'chimique'];
  var DIAG_LABEL = {
    bacterio: 'Bactériologie',
    gout: 'Goût — chlore & sous-produits',
    particule: 'Microplastiques & particules',
    chimique: 'Micropolluants & PFAS',
    mineraux: 'Minéraux',
  };
  var DIAG_VERDICT = {
    vert: 'Rien à signaler',
    ambre: 'À surveiller',
    rouge: 'Dépassement relevé',
    info: 'Informatif',
  };
  function diagSection(analysis) {
    var byId = {};
    (analysis.indicateurs || []).forEach(function (i) { byId[i.id] = i; });
    var picked = DIAG_ORDER.map(function (id) { return byId[id]; }).filter(Boolean);
    if (!picked.length) picked = (analysis.indicateurs || []).slice(0, 3);
    if (!picked.length) return '';
    return '<div class="dy-diag">' + picked.map(function (indic) {
      var st = indic.statutBloc || 'info';
      var cls = st === 'rouge' ? 'bad' : st === 'ambre' ? 'warn' : st === 'vert' ? 'good' : 'info';
      var icon = st === 'rouge' ? 'cross' : st === 'ambre' ? 'warn' : st === 'vert' ? 'check' : 'info';
      var subs = indic.substances || [];
      var det = subs.filter(function (x) { return x.detecte; }).length;
      var sub = subs.length
        ? det + ' détectée' + (det > 1 ? 's' : '') + ' sur ' + subs.length + ' recherchée' + (subs.length > 1 ? 's' : '')
        : 'aucune donnée sur 12 mois';
      return '' +
        '<div class="dy-diag__item">' +
          '<span class="dy-diag__mark dy-diag__mark--' + cls + '" aria-hidden="true">' + svg(icon) + '</span>' +
          '<div class="dy-diag__txt">' +
            '<p class="dy-diag__lbl">' + esc(DIAG_LABEL[indic.id] || indic.titre) + '</p>' +
            '<p class="dy-diag__val">' + esc(DIAG_VERDICT[st] || 'Informatif') + '</p>' +
            '<p class="dy-diag__sub">' + esc(sub) + '</p>' +
          '</div>' +
        '</div>';
    }).join('') + '</div>';
  }

  // Met en valeur (terracotta) le nombre de substances dans le titre du verdict.
  function highlightTitre(titre) {
    return esc(titre).replace(/(\d[\d\u00a0 ]*\s+substances?)/i, '<em>$1</em>');
  }

  function summarySection(analysis) {
    var v = analysis.verdict || {};
    var loc = analysis.commune ? (analysis.commune.nom + ' (' + analysis.commune.code + ')') : '';
    var res = (analysis.reseaux || []).map(function (r) { return r.nom; }).filter(Boolean).join(', ');
    var per = analysis.periode || {};
    var perTxt = per.debut ? ('du ' + frDate(per.debut) + ' au ' + frDate(per.fin)) : '12 mois glissants';
    return '' +
      '<div class="dy-summary">' +
        '<p class="dy-eyebrow dy-eyebrow--light">Votre eau · ' + esc(analysis.commune ? analysis.commune.nom : '') + '</p>' +
        '<p class="dy-summary__loc"><strong>' + esc(loc) + '</strong>' + (res ? ' · réseau : ' + esc(res) : '') + ' · ' + esc(perTxt) + '</p>' +
        '<div class="dy-verdict">' +
          '<h2>' + highlightTitre(v.titre || '') + '</h2>' +
          '<p>' + esc(v.texte || '') + '</p>' +
        '</div>' +
        diagSection(analysis) +
        '<div class="dy-kpis">' +
          kpi(analysis.nbPrelevements, 'prélèvements sur 12 mois') +
          kpi(analysis.nbParametres, 'paramètres recherchés') +
          kpi(analysis.nbSubstancesDetectees, 'substances détectées') +
          kpi(conformiteTxt(analysis.conformite), 'conformité réglementaire', true) +
        '</div>' +
      '</div>';
  }
  function kpi(v, l, isText) {
    return '<div class="dy-kpi"><div class="dy-kpi__v"' + (isText ? ' style="font-size:1.05rem"' : '') + '>' + esc(v) + '</div><div class="dy-kpi__l">' + esc(l) + '</div></div>';
  }
  function conformiteTxt(c) { return c === 'conforme' ? 'Conforme' : c === 'non_conforme' ? 'Non conforme' : 'N.C.'; }
  function frDate(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }); }
    catch (e) { return String(iso).slice(0, 10); }
  }

  /* ----------------------------- lead form ------------------------------ */
  function leadSection() {
    return '' +
      '<section class="dy-lead" id="dy-lead" aria-label="Recevoir le rapport">' +
        '<h3>Recevez votre rapport complet en PDF</h3>' +
        '<p class="dy-lead__sub">Le détail commune par commune, les sources et la solution adaptée. Sans engagement.</p>' +
        '<form class="dy-lead__form" novalidate>' +
          '<div class="dy-field"><label for="dy-prenom">Prénom</label><input id="dy-prenom" name="prenom" type="text" autocomplete="given-name" required></div>' +
          '<div class="dy-grid2">' +
            '<div class="dy-field"><label for="dy-email">E-mail</label><input id="dy-email" name="email" type="email" autocomplete="email" inputmode="email" placeholder="vous@exemple.fr"></div>' +
            '<div class="dy-field"><label for="dy-tel">Téléphone (optionnel)</label><input id="dy-tel" name="tel" type="tel" autocomplete="tel" inputmode="tel"></div>' +
          '</div>' +
          '<div class="dy-field"><label class="dy-consent"><input type="checkbox" name="consent" value="1">' +
            '<span>J\'accepte que Dyese utilise ces informations pour m\'envoyer mon rapport et des conseils sur la qualité de l\'eau. Je peux me désinscrire à tout moment. <a href="#dy-mentions">Politique de confidentialité</a>.</span>' +
          '</label></div>' +
          '<p class="dy-lead__err" hidden></p>' +
          '<button type="submit" class="dy-btn dy-btn--block">' + svg('dl') + ' Recevoir mon rapport PDF</button>' +
        '</form>' +
        '<p class="dy-footnote">Aucune donnée personnelle ne transite par l\'URL. Les mesures d\'audience ne se déclenchent qu\'après votre consentement cookies.</p>' +
      '</section>';
  }

  /* ------------------------- rendu de haut niveau ----------------------- */
  function renderInto(container, analysis, config) {
    // attache les PFAS au bloc chimique pour le rendu
    (analysis.indicateurs || []).forEach(function (i) { if (i.id === 'chimique') i._pfas = analysis.pfas; });

    container.innerHTML = summarySection(analysis) +
      ancresNav(analysis) +
      compositionSection(analysis) +
      focusSection(analysis) +
      ctaBanner('Votre commune est analysée. Pas encore votre foyer.',
                'Recevez le détail complet et la solution adaptée à ce que révèle votre eau.') +
      '<p class="dy-eyebrow">Le détail, indicateur par indicateur</p>';
    var wrap = document.createElement('div');
    (analysis.indicateurs || []).forEach(function (indic, idx) { wrap.appendChild(blockEl(indic, idx)); });
    container.appendChild(wrap);

    container.insertAdjacentHTML('beforeend', trustBar(analysis));
    container.insertAdjacentHTML('beforeend', '<p class="dy-eyebrow">Ce qui correspond à votre eau</p>');
    container.insertAdjacentHTML('beforeend', recoSection(analysis, config));
    container.insertAdjacentHTML('beforeend', '<p class="dy-eyebrow">Votre rapport complet</p>');
    container.insertAdjacentHTML('beforeend', leadSection());
    // Les liens « Voir les N substances » ouvrent le bloc cible avant d'y sauter.
    container.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('.dy-fam__link');
      if (!a) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t && t.tagName === 'DETAILS') t.open = true;
    });

    container.insertAdjacentHTML('beforeend',
      '<p class="dy-footnote">Données : ' + esc(analysis.meta && analysis.meta.source) +
      '. Analyse indicative fondée sur les prélèvements publics ; elle ne remplace pas un avis sanitaire officiel. ' +
      'Dyese ne revendique aucune élimination de substances que ses filtres ne traitent pas.</p>');
    return container;
  }

  return { renderInto: renderInto, _chip: chip, _gauge: gauge, _esc: esc, _nf: nf };
});
